export default __webpack_public_path__ + "static/media/Tier1.8cd9d68e.png";